var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return Object.keys(_vm.inquiry).length ? _c('div', {
    attrs: {
      "id": "inquiry-edit"
    }
  }, [_c('inquiryInfoCard', {
    attrs: {
      "inquiry": _vm.inquiry
    }
  }), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('header', {
    staticClass: "theme--light v-navigation-drawer elevation-1",
    staticStyle: {
      "height": "50px",
      "border-radius": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__content",
    staticStyle: {
      "height": "50px",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__title"
  }, [_c('h4', {
    staticClass: "black--text"
  }, [_vm._v("Description")])])])]), _c('v-card', [_c('v-card-text', {
    staticClass: "text--primary text-body-1",
    staticStyle: {
      "min-height": "200px",
      "margin-bottom": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.inquiry.description)
    }
  })], 1), _vm.invoices && _vm.invoices.length > 0 ? _c('div', {
    staticClass: "invoices-container mb-6",
    style: _vm.invoices.length > 2 ? 'max-height: 400px; overflow-y: auto;' : ''
  }, _vm._l(_vm.invoices, function (invoice, index) {
    return invoice ? _c('invoiceInfo', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "invoice": invoice
      }
    }) : _vm._e();
  }), 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('ClaimCustomer', {
    attrs: {
      "customer": _vm.inquiry.customer,
      "inquiry-id": _vm.inquiryId
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('header', {
    staticClass: "theme--light v-navigation-drawer elevation-1",
    staticStyle: {
      "height": "50px",
      "border-radius": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__content",
    staticStyle: {
      "height": "50px",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__title"
  }, [_c('h4', {
    staticClass: "black--text"
  }, [_vm._v("Activity Log")])])])]), _c('v-card', [_c('v-card-text', [_c('v-timeline', {
    attrs: {
      "dense": "",
      "align-top": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "icon": "mdi-account",
      "fill-dot": "",
      "large": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Status")]), _c('ValidationObserver', {
    ref: "eventObserver",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var Validate = _ref.Validate,
          reset = _ref.reset;
        return [_c('ValidationProvider', {
          attrs: {
            "name": "code",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-select', {
                attrs: {
                  "id": "select",
                  "items": _vm.eventStatus,
                  "item-text": "label",
                  "item-value": "value",
                  "error-messages": errors,
                  "outlined": "",
                  "dense": ""
                },
                model: {
                  value: _vm.event.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "code", $$v);
                  },
                  expression: "event.code"
                }
              })];
            }
          }], null, true)
        }), _vm.event.code.includes('refund') ? _c('ValidationProvider', {
          attrs: {
            "name": "refundAmount",
            "rules": "required|numeric"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                attrs: {
                  "error-messages": errors,
                  "type": "number",
                  "label": "Amount of refund",
                  "filled": ""
                },
                model: {
                  value: _vm.event.refundAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "refundAmount", _vm._n($$v));
                  },
                  expression: "event.refundAmount"
                }
              })];
            }
          }], null, true)
        }) : _vm._e(), _vm.event.code.includes('refund') ? _c('v-text-field', {
          attrs: {
            "label": "Referenced Booking Number (special credit)",
            "filled": "",
            "type": "String"
          },
          model: {
            value: _vm.event.referencedBookingNumber,
            callback: function ($$v) {
              _vm.$set(_vm.event, "referencedBookingNumber", $$v);
            },
            expression: "event.referencedBookingNumber"
          }
        }) : _vm._e(), _c('ValidationProvider', {
          attrs: {
            "name": "message"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var errors = _ref4.errors;
              return [_c('v-textarea', {
                attrs: {
                  "error-messages": errors,
                  "label": "Leave a comment...",
                  "filled": ""
                },
                model: {
                  value: _vm.event.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "message", $$v);
                  },
                  expression: "event.message"
                }
              })];
            }
          }], null, true)
        })];
      }
    }], null, false, 393919609)
  }), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "loading": _vm.event.loading,
      "color": "accent",
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.createEvent();
      }
    }
  }, [_vm._v("Post ")])], 1), _c('event-list', {
    attrs: {
      "eventStatus": _vm.eventStatus,
      "events": _vm.inquiry.events,
      "getInquiry": _vm.init,
      "inquiryId": _vm.inquiryId
    }
  })], 1)], 1)], 1)], 1)], 1), _c('float-buttons', {
    attrs: {
      "inquiry": _vm.inquiry
    },
    on: {
      "addEvent": function ($event) {
        return _vm.inquiry.events.unshift($event);
      }
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }